'use client';

import { PropsWithChildren } from 'react';

import { cn } from '~/lib/utils/classname';

interface Props extends PropsWithChildren {
  side?: 'left' | 'right';
  className?: string;
}

const ExpandToEdge: React.FC<Props> = ({
  side = 'left',
  className,
  children,
}) => {
  return (
    <div className={cn('relative', className)}>
      <div
        className={cn(
          'relative h-full w-[calc(100%+max((100vw-var(--layout-grid-max-width))*0.5,var(--layout-grid-padding--lg)))]',
          {
            'left-[calc(-1*max((100vw-var(--layout-grid-max-width))*0.5,var(--layout-grid-padding--lg)))]':
              side === 'left',
          }
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default ExpandToEdge;
